import React, { useEffect } from "react";
import { usePreloader } from "./PreloaderContext";
import { useLocation } from "react-router-dom";
import preloaderimg from "../src/assets/images/wait.gif";

const Preloader = () => {
  const { loading, setLoading } = usePreloader();
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location, setLoading]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 1000,
        display: loading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={preloaderimg}
        alt="Loading..."
        style={{
          width: "100px",
          height: "100px",
        }}
      />
    </div>
  );
};

export default Preloader;
